var map = {
	"./alimentacion.png": "/6EL",
	"./alimentacion@0,5x.png": "fSq7",
	"./arte.png": "6F2u",
	"./arte@0,5x.png": "0mPV",
	"./asesorias.png": "Qniu",
	"./asesorias@0,5x.png": "JiTM",
	"./default.png": "+zm6",
	"./e18.png": "CSpG",
	"./e18@0,5x.png": "n8Ph",
	"./eventos.png": "nduY",
	"./eventos@0,5x.png": "GrWr",
	"./hosting.png": "7140",
	"./hosting@0,5x.png": "fnJi",
	"./inmueble.png": "rBfV",
	"./inmueble@0,5x.png": "LL4f",
	"./juegos.png": "psrS",
	"./juegos@0,5x.png": "dqX3",
	"./juridicos.png": "8HVR",
	"./juridicos@0,5x.png": "v+Nw",
	"./pagos.png": "ewpq",
	"./pagos@0,5x.png": "nidB",
	"./prepago.png": "+uYu",
	"./prepago@0,5x.png": "5Xyu",
	"./productosvarios.png": "nKaB",
	"./productosvarios@0,5x.png": "17TE",
	"./remesas.png": "CCGI",
	"./remesas@0,5x.png": "W0J4",
	"./saludbelleza.png": "ggzC",
	"./saludbelleza@0,5x.png": "ITAh",
	"./tech.png": "qzNa",
	"./tech@0,5x.png": "RcIN",
	"./turismo.png": "Ph5p",
	"./turismo@0,5x.png": "QE4n",
	"./vestuario.png": "1S6M",
	"./vestuario@0,5x.png": "zT6l",
	"./viajes.png": "qSpQ",
	"./viajes@0,5x.png": "BNKh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uJR8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/categories ^\.\/.*$
// module id = uJR8
// module chunks = 1